const pad2 = (value: number) => String(value).padStart(2, '0');

export const getTodayInputDate = () => {
  const today = new Date();
  return `${today.getFullYear()}-${pad2(today.getMonth() + 1)}-${pad2(today.getDate())}`;
};

export const inputDateToLocalDate = (dateString: string) => {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const isInputDateBeforeToday = (dateString: string) => {
  const selectedDate = inputDateToLocalDate(dateString);
  const today = inputDateToLocalDate(getTodayInputDate());
  return selectedDate < today;
};

export const inputDateToLocalDateTimeString = (dateString: string) => `${dateString}T00:00:00`;

export const parseBackendLocalDateTime = (dateString?: string) => {
  if (!dateString) return null;

  const hasExplicitTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(dateString);
  if (hasExplicitTimezone) {
    const date = new Date(dateString);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const match = dateString.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,3}))?)?)?/
  );

  if (!match) {
    const date = new Date(dateString);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const [, year, month, day, hour = '0', minute = '0', second = '0', millisecond = '0'] = match;
  return new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
    Number(second),
    Number(millisecond.padEnd(3, '0'))
  );
};
